import { Component, inject, Input, OnInit } from "@angular/core";
import {
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';

import { UserService } from '@beautyapp/core';
import { NZ_MODAL_DATA, NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { NzColDirective, NzRowDirective } from 'ng-zorro-antd/grid';
import { InputModule } from '@beautyapp/form';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonComponent } from 'ng-zorro-antd/button';

@Component({
    selector: 'beautyapp-add-employee-appointment-user',
    templateUrl: './add-employee-appointment-user.component.html',
    styleUrls: ['./add-employee-appointment-user.component.scss'],
  imports: [
    ReactiveFormsModule,
    NzRowDirective,
    InputModule,
    NzColDirective,
    TranslatePipe,
    NzModalFooterDirective,
    NzButtonComponent

  ]
})
export class AddEmployeeAppointmentUserComponent implements OnInit {
  modal = inject(NzModalRef);
  private userService = inject(UserService);
  private fb = inject(UntypedFormBuilder);

  readonly data = inject(NZ_MODAL_DATA);

  get userId() {
    return this.data.userId;
  }

  form: UntypedFormGroup;

  constructor() {
    this.form = this.fb.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      mobilePhone: [null, Validators.required],
    });
  }

  ngOnInit(): void {}

  submit(): void {
    if (this.form.invalid) return;
    this.userService.create(this.form.value).subscribe((res) => {
      console.log(res);
      this.modal.close(res);
    });
  }
}
